import { useState } from "react";
import { List, X, Barbell, ChartLineUp, CalendarBlank, BowlFood, Brain, PersonSimpleRun, GearSix, Trophy, CaretDown, CaretRight, ListChecks, Target } from "@phosphor-icons/react";

const WORKOUT_CATEGORIES = [
  { id: "all", label: "All Workouts" },
  { id: "Strength", label: "Strength" },
  { id: "Mass", label: "Mass" },
  { id: "Cardio", label: "Cardio" },
];

const navItems = [
  { id: "dashboard", label: "Summary", icon: ChartLineUp },
  { id: "calendar", label: "Schedule", icon: CalendarBlank },
  { id: "body", label: "Body", icon: PersonSimpleRun },
  { id: "macros", label: "Calories", icon: BowlFood },
  { id: "ai", label: "Coach", icon: Brain },
  { id: "prs", label: "PRs", icon: Trophy },
  { id: "settings", label: "Settings", icon: GearSix },
];

export default function MobileNav({ activeTab, setActiveTab, onCategoryChange }) {
  const [open, setOpen] = useState(false);
  const [workoutsOpen, setWorkoutsOpen] = useState(false);

  const isWorkoutsActive = activeTab === "templates" || activeTab === "logger";

  const handleWorkoutCategory = (catId) => {
    onCategoryChange?.(catId === "all" ? null : catId);
    setActiveTab("templates");
    setOpen(false);
  };

  return (
    <div className="md:hidden fixed top-0 left-0 right-0 z-50" data-testid="mobile-nav">
      <div className="bg-[#0F0F0F]/95 backdrop-blur-xl border-b border-[#27272A] px-4 py-3 flex items-center justify-between">
        <h1
          className="text-lg font-black tracking-tighter uppercase text-white"
          style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
        >
          <span className="text-[#E05A1D]">UP</span>TOP
        </h1>
        <button
          onClick={() => setOpen(!open)}
          className="text-[#A1A1AA] hover:text-white transition-colors"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>
      {open && (
        <div className="bg-[#161616] border-b border-[#27272A] py-2 max-h-[80vh] overflow-y-auto">
          {navItems.map((item) => {
            if (item.id === "calendar") {
              return (
                <div key="workouts-mobile-group">
                  <button
                    onClick={() => setWorkoutsOpen(!workoutsOpen)}
                    className={`w-full flex items-center justify-between px-5 py-3 text-sm font-semibold uppercase tracking-wider transition-colors ${
                      isWorkoutsActive ? "text-[#E05A1D] bg-[#E05A1D]/5" : "text-[#A1A1AA] hover:text-white"
                    }`}
                    data-testid="mobile-nav-workouts"
                  >
                    <div className="flex items-center gap-3">
                      <ListChecks size={18} weight={isWorkoutsActive ? "fill" : "regular"} />
                      Workouts
                    </div>
                    {workoutsOpen ? <CaretDown size={14} /> : <CaretRight size={14} />}
                  </button>
                  {workoutsOpen && (
                    <div className="ml-8 border-l border-[#27272A]">
                      <button
                        onClick={() => { setActiveTab("logger"); setOpen(false); }}
                        className={`w-full text-left px-4 py-2.5 text-xs font-semibold uppercase tracking-wider flex items-center gap-2 transition-colors ${
                          activeTab === "logger" ? "text-[#E05A1D]" : "text-[#71717A] hover:text-white"
                        }`}
                        data-testid="mobile-nav-logger"
                      >
                        <Barbell size={12} weight="bold" /> Log Workout
                      </button>
                      {WORKOUT_CATEGORIES.map((cat) => (
                        <button
                          key={cat.id}
                          onClick={() => handleWorkoutCategory(cat.id)}
                          className="w-full text-left px-4 py-2.5 text-xs font-semibold uppercase tracking-wider text-[#71717A] hover:text-white transition-colors"
                          data-testid={`mobile-nav-workout-${cat.id}`}
                        >
                          {cat.label}
                        </button>
                      ))}
                    </div>
                  )}

                  <button
                    onClick={() => { setActiveTab("plans"); setOpen(false); }}
                    className={`w-full flex items-center gap-3 px-5 py-3 text-sm font-semibold uppercase tracking-wider transition-colors ${
                      activeTab === "plans" ? "text-[#E05A1D] bg-[#E05A1D]/5" : "text-[#A1A1AA] hover:text-white"
                    }`}
                    data-testid="mobile-nav-plans"
                  >
                    <Target size={18} weight={activeTab === "plans" ? "fill" : "regular"} />
                    Plans
                  </button>

                  <button
                    onClick={() => { setActiveTab(item.id); setOpen(false); }}
                    className={`w-full flex items-center gap-3 px-5 py-3 text-sm font-semibold uppercase tracking-wider transition-colors ${
                      activeTab === item.id ? "text-[#E05A1D] bg-[#E05A1D]/5" : "text-[#A1A1AA] hover:text-white"
                    }`}
                    data-testid={`mobile-nav-${item.id}`}
                  >
                    <item.icon size={18} weight={activeTab === item.id ? "fill" : "regular"} />
                    {item.label}
                  </button>
                </div>
              );
            }

            return (
              <button
                key={item.id}
                onClick={() => { setActiveTab(item.id); setOpen(false); }}
                className={`w-full flex items-center gap-3 px-5 py-3 text-sm font-semibold uppercase tracking-wider transition-colors ${
                  activeTab === item.id ? "text-[#E05A1D] bg-[#E05A1D]/5" : "text-[#A1A1AA] hover:text-white"
                }`}
                data-testid={`mobile-nav-${item.id}`}
              >
                <item.icon size={18} weight={activeTab === item.id ? "fill" : "regular"} />
                {item.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
